import { Store } from '@jwplayer/fe-common/module/store/react';

import type { QueryMockConfig } from './mocks/types';

export const DebugStore = new Store<{
  readOnly: boolean | 'botr';
  mockConfigs: Record<string, QueryMockConfig>;
}>({
  readOnly: false,
  mockConfigs: {},
});
